import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { ScrollArea } from './ui/scroll-area';
import { FileCheck2 } from 'lucide-react';

const P = ({ children }) => (
  <p className="text-[13px] leading-relaxed text-gray-600">{children}</p>
);

export const VeracityDialog = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-2xl p-0 gap-0 overflow-hidden" data-testid="veracity-dialog">
      <DialogHeader className="px-6 pt-6 pb-4 border-b bg-gradient-to-r from-blue-50 to-sky-50">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center shrink-0">
            <FileCheck2 className="w-5 h-5 text-blue-600" />
          </div>
          <div className="text-left">
            <DialogTitle className="text-base font-extrabold text-gray-900">
              Veracidade dos Dados Cadastrais e Fiscais
            </DialogTitle>
            <DialogDescription className="text-xs text-gray-500">
              FOX SELLER — MoedasOnline.com
            </DialogDescription>
          </div>
        </div>
      </DialogHeader>
      <ScrollArea className="max-h-[62vh]">
        <div className="px-6 py-5 space-y-4" data-testid="veracity-content">
          <P>
            Ao realizar seu cadastro ou efetuar compras na FOX SELLER, por meio do domínio
            moedasonline.com, o usuário declara e garante que todas as informações fornecidas são
            <b> verdadeiras, completas, atualizadas</b> e correspondem à sua identidade e aos seus
            dados oficiais, especialmente nome completo, CPF ou outro documento de identificação,
            endereço, informações de contato e demais dados necessários ao processamento fiscal,
            financeiro e contábil das operações realizadas.
          </P>
          <P>
            Os dados solicitados são necessários para a identificação do comprador, processamento
            das transações, cumprimento de obrigações fiscais e contábeis, prevenção a fraudes,
            segurança da plataforma e atendimento às obrigações legais e regulatórias aplicáveis.
          </P>
          <P>
            Não é permitida a realização de compras de forma anônima quando a identificação do
            comprador for necessária, nem a utilização deliberada de dados falsos, fictícios,
            adulterados, pertencentes a terceiros sem autorização ou qualquer outra informação
            destinada a ocultar ou falsificar a identidade do responsável pela operação.
          </P>
          <P>
            O usuário é responsável pela exatidão e legitimidade das informações fornecidas e
            compromete-se a mantê-las atualizadas.
          </P>
          <div className="space-y-2">
            <P>
              Caso sejam identificados indícios de inconsistência, falsidade, fraude, uso indevido
              de dados de terceiros ou qualquer outra irregularidade, a FOX SELLER poderá,
              observados os limites da legislação aplicável:
            </P>
            <ul className="list-disc pl-5 space-y-1 text-[13px] leading-relaxed text-gray-600">
              <li>solicitar documentos ou informações adicionais para verificação de identidade e titularidade;</li>
              <li>suspender ou cancelar cadastros, pedidos ou transações enquanto a irregularidade estiver sendo analisada;</li>
              <li>recusar novas operações quando houver risco de fraude ou descumprimento das regras da plataforma;</li>
              <li>preservar registros, documentos e evidências relacionados às operações pelo período permitido ou exigido pela legislação;</li>
              <li>adotar as medidas administrativas e judiciais cabíveis; e</li>
              <li>comunicar os fatos às autoridades competentes quando houver obrigação legal, determinação de autoridade ou indícios que justifiquem tal providência nos termos da legislação aplicável.</li>
            </ul>
          </div>
          <P>
            <b>
              O fornecimento intencional de informações falsas, a utilização fraudulenta de dados de
              terceiros ou a falsificação/adulteração de documentos poderá sujeitar o responsável às
              consequências civis, administrativas e/ou criminais previstas na legislação brasileira
            </b>
            , conforme a natureza e as circunstâncias da conduta.
          </P>
          <P>
            O tratamento e a conservação desses dados serão realizados de acordo com a Lei nº
            13.709/2018 (Lei Geral de Proteção de Dados Pessoais — LGPD) e demais normas aplicáveis,
            exclusivamente para finalidades legítimas relacionadas à operação da plataforma e ao
            cumprimento de suas obrigações.
          </P>
          <div className="pt-2 border-t text-center">
            <p className="text-xs font-bold text-gray-800">FOX SELLER</p>
            <p className="text-[11px] text-gray-400">Plataforma disponível em MoedasOnline.com</p>
          </div>
        </div>
      </ScrollArea>
    </DialogContent>
  </Dialog>
);

export default VeracityDialog;
